import { motion } from 'framer-motion';
import { SectionContent } from '@/contexts/ContentContext';
import { FaDoorClosed, FaBuilding, FaChair, FaPalette, FaTools, FaCogs } from 'react-icons/fa';

const iconComponents: Record<string, React.ElementType> = {
  FaDoorClosed,
  FaBuilding,
  FaChair,
  FaPalette,
  FaTools,
  FaCogs,
};

interface ServicesPreviewProps {
  content: SectionContent;
}

export default function ServicesPreview({ content }: ServicesPreviewProps) {
  if (!content.services) return null;

  return (
    <div className="space-y-4 p-4 bg-gray-50 rounded-lg">
      <div className="text-center">
        <h3 className="text-xl font-bold text-gray-900">{content.title || 'Nossos Serviços'}</h3>
        {content.subtitle && (
          <p className="text-gray-600 mt-1">{content.subtitle}</p>
        )}
        {content.description && (
          <p className="text-gray-700 mt-2">{content.description}</p>
        )}
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        {content.services.map((service, index) => {
          const IconComponent = iconComponents[service.icon] || FaCogs;
          
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="text-primary-600 mb-4">
                <IconComponent className="h-8 w-8" />
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                {service.title}
              </h4>
              <p className="text-gray-600">{service.description}</p>
            </motion.div>
          );
        })}
      </div>
      
      {content.cta && (
        <div className="mt-8 text-center">
          <button className="px-6 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors">
            {content.cta}
          </button>
        </div>
      )}
    </div>
  );
}
